import { createAsyncThunk } from '@reduxjs/toolkit';
import { MpOrdersMarkingApi } from '@/Api/MpOrdersMarking/MpOrdersMarkingApi';
import {
  ChangeOrderPaymentStatusByMarkerRequest,
  ChangeOrderPaymentStatusPartiallyByMarkerRequest,
  ChangeOrderPaymentStatusToPaidForSingleOrderRequest,
} from '@/Api/MpOrdersMarking/Requests';
import { OrderModel } from '@/Models/Order/OrderModel';

const changePaymentStatus = createAsyncThunk<OrderModel[], ChangeOrderPaymentStatusByMarkerRequest>(
  'changePaymentModal/change-payment-status',
  async (request) => {
    return MpOrdersMarkingApi.changeOrderPaymentStatus(request);
  },
);

const changePaymentStatusSingle = createAsyncThunk<OrderModel, ChangeOrderPaymentStatusToPaidForSingleOrderRequest>(
  'changePaymentModal/change-payment-status-single',
  async (request) => {
    return MpOrdersMarkingApi.changePaymentStatusSingle(request);
  },
);

const changeOrderPaymentStatusPartially = createAsyncThunk<
  OrderModel[],
  ChangeOrderPaymentStatusPartiallyByMarkerRequest
>('changePaymentModal/change-payment-status-partially', async (request) => {
  return MpOrdersMarkingApi.changeOrderPaymentStatusPartially(request);
});

export const changePaymentAsyncActions = {
  changePaymentStatus,
  changePaymentStatusSingle,
  changeOrderPaymentStatusPartially,
};
